const CoffeMass=[
    {
      id:1,
        title:"Рістретто 0,020л",
        price:"40 грн",
        src: require('../img/espresso.png'),
        text:"",
    },
    {
        id:2,
        title:"Еспресо 0,030л",
        price:"40 грн",
        src: require('../img/espresso.png'),
        text:"",
    },
    {
        id:3,
        title:"Американо 0,120л",
        price:"40 грн",
        src: require('../img/americano.png'),
        text:"",
    },
    {
        id:4,
        title:"Допіо 0,060л",
        price:"69 грн",
        src: require('../img/espresso.png'),
        text:"",
    },
    {
        id:5,
        title:"Капучино 0,160л",
        price:"59 грн",
        src: require('../img/capuchino.png'),
        text:"",
    },
    //{
        //id:6,
        //title:"Капучино на безлактозному молоці 0,160л",
        //price:"50 грн",
        //src: require('../img/cof.webp'),
        //text:"",
    //},
    {
        id:7,
        title:"Лате 0,200л",
        price:"59 грн",
        src: require('../img/late.png'),
        text:"",
    },
    // {
    //     id:8,
    //     title:"Лате на безлактозному молоці 0,200л",
    //     price:"55 грн",
    //     src: require('../img/cof.webp'),
    //     text:"",
    // },
    {
        id:9,
        title:"Латте макіатто 0,200л",
        price:"59 грн",
        src: require('../img/late.png'),
        text:"",
    },
    // {
    //     id:10,
    //     title:"Кайджицо 0,350л",
    //     price:"79 грн",
    //     src: require('../img/cof.webp'),
    //     text:"",
    // },
    {
        id:11,
        title:"Гляссе 0,120л",
        price:"79 грн",
        src: require('../img/glyase.png'),
        text:"",
    },
    // {
    //     id:12,
    //     title:"Афогатто 0,120л",
    //     price:"75 грн",
    //     src: require('../img/cof.webp'),
    //     text:"",
    // },
    // {
    //     id:13,
    //     title:"Кокосова кава 0,350л",
    //     price:"75 грн",
    //     src: require('../img/cof.webp'),
    //     text:"",
    // },
    // {
    //     id:14,
    //     title:"Шейк 0,350л",
    //     price:"69 грн",
    //     src: require('../img/shakecof.png'),
    //     text:"",
    // },
    {
        id:15,
        title:"Какао з маршмелоу 0,250л",
        price:"75 грн",
        src: require('../img/shakecof.png'),
        text:"",
    },
    
    {
        id:16,
        title:"айс лате 0,250л",
        price:"65 грн",
        src: '',
        text:"",
    },
    
]

export default CoffeMass;